import React, { useEffect } from 'react'
import { View, SafeAreaView } from 'react-native'
import { useWindowSize } from 'react-use'

import { getUserData } from '@hedgit/lib/store/modules/auth/thunks'
import { getSubscriptionOptions } from '@hedgit/lib/store/modules/subscription-options/thunks'

import useSafeArea from '@hedgit/lib/hooks/use-safe-area'

import { UserRole } from '@hedgit/lib/enums/user-role'

import { useSelector, RootState, useDispatch } from 'store'

import useAuthToken from 'hooks/use-auth-token'

import { AppNavigator } from './app'
import { AuthNavigator } from './auth'

const Navigator = () => {
  const dispatch = useDispatch()
  const token = useSelector((store: RootState) => store.auth.token)
  const isSignIn = useSelector((store: RootState) => store.auth.isSignIn)
  const currentUser = useSelector((store: RootState) => store.auth.currentUser)

  const isSignedIn = token

  const { height } = useWindowSize()
  const { bottom } = useSafeArea()

  useAuthToken()

  useEffect(() => {
    if (token && isSignIn) {
      dispatch(getUserData())
    }
  }, [token, dispatch, isSignIn])

  useEffect(() => {
    if (currentUser && currentUser.role === UserRole.farmer) {
      dispatch(getSubscriptionOptions())
    }
  }, [currentUser, dispatch])

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = window.visualViewport?.height + 'px'
    }
  }, [height])

  return (
    <View
      style={{ height: height + bottom, overflow: 'hidden', display: 'flex', maxHeight: '100vh' }}
    >
      <SafeAreaView style={{ flex: 1 }}>
        {isSignedIn ? <AppNavigator /> : <AuthNavigator />}
      </SafeAreaView>
    </View>
  )
}

export default Navigator
